// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__+g7FD","profile":"style_profile__bTx3e","left":"style_left__8apWy"};